import React, { createContext, useContext, useEffect, useState } from "react"

export type BrandTheme = "PROTO_FAUNA" | "PROTO_INDUSTRIAL"

interface BrandThemeContextType {
  theme: BrandTheme
  setTheme: (theme: BrandTheme) => void
  toggleTheme: () => void
}

const BrandThemeContext = createContext<BrandThemeContextType | undefined>(undefined)

export const BrandThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setThemeState] = useState<BrandTheme>(() => {
    const saved = localStorage.getItem("meatbid-brand-theme")
    return (saved as BrandTheme) || "PROTO_FAUNA"
  })

  const setTheme = (newTheme: BrandTheme) => {
    setThemeState(newTheme)
    localStorage.setItem("meatbid-brand-theme", newTheme)
  }

  const toggleTheme = () => {
    setTheme(theme === "PROTO_FAUNA" ? "PROTO_INDUSTRIAL" : "PROTO_FAUNA")
  }

  useEffect(() => {
    const root = window.document.documentElement
    if (theme === "PROTO_INDUSTRIAL") {
      root.classList.add("theme-industrial")
    } else {
      root.classList.remove("theme-industrial")
    }
  }, [theme])

  return (
    <BrandThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </BrandThemeContext.Provider>
  )
}

export const useBrandTheme = () => {
  const context = useContext(BrandThemeContext)
  if (context === undefined) {
    throw new Error("useBrandTheme must be used within a BrandThemeProvider")
  }
  return context
}

